<mat-card [ngClass]="type" class="card" [style.width]="width">{{ message }}</mat-card>
